import axios from "axios";

const request = axios.create({
    baseURL:  global.$config.api.analysisUrl,
    // baseURL: "https://biaozhunhua.zjht100.com/tsscanalysis/",
    timeout: "30000",
    method: "post"
})


export const post = ({url, data, success, baseURL, params={}, headers={}}) => {
    console.log(data, url);
    return new Promise((resolve, reject) => {
        request({
            url,
            headers,
            params,
            data: {...data},
            baseURL
        }).then((res) => {
            success(res.data.data);
            resolve(res.data.data);
        }).catch(reject)
    });
}

const request2 = axios.create({
    baseURL:  global.$config.api.analysisUrl,
    // baseURL: "https://biaozhunhua.zjht100.com/tsscanalysis/",
    timeout: "30000",
    method: "get"
})


export const get = ({url, data, success, baseURL, params={}, headers={}}) => {
    console.log(data, url);
    return new Promise((resolve, reject) => {
        request2({
            url,
            headers,
            params,
            data: {...data},
            baseURL
        }).then((res) => {
            success(res.data.data);
            resolve(res.data.data);
        }).catch(reject)
    });
}